import axios from "axios";
import config from "@/router/globalConfig";

export default {
    //============= Post API ===============
    SubmitLicense(_data_) {
        return axios.post(config.WEB_API_PATH + 'login/v1/SubmitLicense', _data_, {
            crossdomain: true,
        });
    },
    //======================================
    //============== Get API ===============
    GetLicense(_data_) {
        return axios.get(config.WEB_API_PATH + 'login/v1/GetLicense', {
            crossdomain: true,
        });
    },
    //======================================
}


// WEBPACK FOOTER //
// ./src/components/serviceJS/licenseJS.js